<div style="padding-left: 15px; padding-top: 10px;">
    <table>
        @for (field of fields; track field) {
            <tr>
                <td style="text-align: left">{{ field.name }}:</td>
                <td style="text-align: left; padding-left: 5px;">{{ field.selectedOption }}</td>
            </tr>
        }
    </table>
</div>
